import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const MonitoringRepository = {
  fetchMetrics: () => {
    return Axios.get(`${SETTINGS.API_URL}metrics/`);
  },
};
